import { render, staticRenderFns } from "./Sub_Footer.vue?vue&type=template&id=e9c507c0&scoped=true&"
import script from "./Sub_Footer.vue?vue&type=script&lang=js&"
export * from "./Sub_Footer.vue?vue&type=script&lang=js&"
import style0 from "./Sub_Footer.vue?vue&type=style&index=0&id=e9c507c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c507c0",
  null
  
)

export default component.exports